import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import ReactGA from "react-ga";
import { appConfig } from "../../variables/appConfig";
ReactGA.initialize(appConfig.googleAnalyticsTrackingId);
export const TrackGA = (WrappedComponent, options = {}) => {
    const trackPage = (page) => {
        ReactGA.set({
            page,
            ...options
        });
        ReactGA.pageview(page);
    };
    const HOC = (props) => {
        useEffect(() => trackPage(props.location.pathname), [props.location.pathname]);
        return _jsx(WrappedComponent, { ...props }, void 0);
    };
    return HOC;
};
//# sourceMappingURL=TrackGA.js.map